import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Funciona con cualquier marca de Air Fryer?',
    answer: 'Sí, las recetas funcionan con cualquier marca y modelo de Air Fryer.'
  }, {
    question: '¿Necesito experiencia cocinando?',
    answer: 'No, las recetas están diseñadas para que cualquier persona pueda prepararlas, incluso si nunca cocinaste antes.'
  }, {
    question: '¿Cómo recibo el producto?',
    answer: 'Inmediatamente después de tu compra recibirás un enlace para descargar todo el material en formato digital.'
  }, {
    question: '¿Puedo verlo en mi celular?',
    answer: 'Sí, el material es compatible con cualquier dispositivo: celular, tablet o computadora.'
  }, {
    question: '¿Qué pasa si no me gusta?',
    answer: 'Tenés 45 días de garantía. Si no estás satisfecho/a, te devolvemos el 100% de tu dinero sin preguntas.'
  }, {
    question: '¿El pago es seguro?',
    answer: 'Sí, utilizamos plataformas de pago certificadas y seguras para proteger tu información.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-dark" data-id="element-43">
      <div className="max-w-3xl mx-auto" data-id="element-44">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-45">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, index) => <div key={index} className="bg-white/5 border border-white/10 rounded-xl overflow-hidden transition-all duration-300" data-id="element-47">
              <button className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-48">
                <span className="font-bold text-lg text-white" data-id="element-49">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-primary transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-50" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-51">
                <p className="text-gray-400" data-id="element-52">{faq.answer}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}